"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = getActiveElement;

function getActiveElement() {
  var rootElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var activeElement = rootElement.activeElement;
  if (!activeElement) return null;
  var shadowRoot = activeElement.shadowRoot;
  return shadowRoot ? getActiveElement(shadowRoot) : activeElement;
}
//# sourceMappingURL=getActiveElement.js.map